<template>
  <tr v-if="row" :class="[{'open': isOpened, 'clickable': clickable, 'more_info': moreInfo}]" @click.prevent="rowClick">
    <td class="no_padding drag_drop" @click.stop="checkboxClick">
      <span />
    </td>
    <td v-if="selectable" class="no_padding" @click.stop.self="checkboxClick">
      <input
          type="checkbox"
          :name="name"
          :id="name"
          v-model="checkboxSelected"
          @change="onChange"
      />
      <label :for="name">Vybrat</label>
    </td>
    <app-table-cell
        v-for="(column, index) in columns"
        :first="index === 0"
        :last="index === columns.length - 1"
        :firstCell="index === 0 && !selectable"
        :key="row._id + column.label"
        :column="column"
        :row="row"
        :value="row[column.attribute]"
    />
    <td class="no_padding" :class="{'edit': deletable}">
      <div class="edit_inner" v-if="deletable || toggleable || copyable">
        <a
            v-if="toggleable"
            class="btn btn_action"
            :class="{'btn_allow': toggle, 'btn_forbid': !toggle}"
            :title="toggleTitle"
            @click.prevent.stop="$emit('toggleRow')"
        />
        <a
            v-if="copyable"
            class="btn btn_action btn_grey btn_duplicate"
            @click.prevent.stop="$emit('copyRow')"
        />
        <a
            class="btn btn_action btn_delete"
            @click.prevent.stop="$emit('deleteRow')"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import ContentItem from '@/components/Show/Common/ContentItem'
import EditableRow from '@/components/Templates/EditableRow'

export default {
  components: { EditableRow, ContentItem },
  props: {
    row: {
      default: null,
      type: Object
    },
    columns: {
      default: null,
      type: Array
    },
    selectable: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    clickable: {
      type: Boolean,
      default: false
    },
    deletable: {
      type: Boolean,
      default: false
    },
    toggleable: {
      type: Boolean,
      default: false
    },
    copyable: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    isOpened: {
      type: Boolean,
      default: false
    },
    moreInfo: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      checkboxSelected: false
    }
  },
  computed: {
    translations() {
      return {
        delete: this.$gettext('Smazat'),
        allow: this.$gettext('Povolit'),
        forbid: this.$gettext('Zakázat')
      }
    },
    toggle() {
      if (this.row.hasOwnProperty('enabled')) {
        return !this.row.enabled
      } else if (this.row.hasOwnProperty('active')) {
        return !this.row.active
      }
    },
    toggleTitle() {
      return (this.row.enabled || this.row.active) ? this.translations.forbid : this.translations.allow
    }
  },
  methods: {
    rowClick() {
      this.$emit('click')
    },
    checkboxClick() {
      this.checkboxSelected = !this.checkboxSelected
      this.$emit('selectRow', this.checkboxSelected)
    },
    onChange(event) {
      this.$emit('selectRow', this.checkboxSelected)
    }
  },
  watch: {
    selected: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.checkboxSelected = newValue
      }
    }
  }
}
</script>
